module.exports = __webpack_public_path__ + "img/029a6a9.png";